<script lang="ts">
export type SellPageHeroBlockProps = {
    title?: string;
    description?: string;
    items: string[];
};
</script>
<script setup lang="ts">
// PROPS
defineProps<SellPageHeroBlockProps>();

// COMPOSABLES
const { phones } = useFleequidContacts();
</script>

<template>
    <BlockSectionFullWidth variant="gradient">
        <!--desktop-->
        <div class="hidden gap-8 lg:flex">
            <div class="flex flex-1 flex-col justify-between gap-9">
                <div class="flex flex-col gap-6">
                    <h1 v-if="!!title" class="text-inverted text-3xl font-semibold">
                        {{ title }}
                    </h1>
                    <p v-if="!!description" class="text-inverted">
                        {{ description }}
                    </p>

                    <div class="flex flex-wrap gap-3">
                        <FleequidWhatsappLink />
                        <UButton
                            v-for="phone in phones"
                            :key="phone"
                            variant="outline"
                            class="hover:bg-primary-100 rounded-lg bg-white"
                            icon="lucide:phone"
                            :label="phone"
                            :href="formatPhoneLink(phone)"
                        />
                    </div>
                </div>

                <BlockList :items="items" class="text-inverted" :list-style="{ type: 'icon', name: 'lucide:circle-check' }" />
            </div>
            <slot />
        </div>

        <!--mobile-->
        <div class="flex flex-col gap-6 lg:hidden">
            <h1 v-if="!!title" class="text-inverted text-3xl font-semibold">
                {{ title }}
            </h1>

            <slot />

            <p v-if="!!description" class="text-inverted">
                {{ description }}
            </p>

            <div class="flex flex-wrap items-stretch gap-3 md:flex-nowrap">
                <FleequidWhatsappLink />
                <UButton
                    v-for="phone in phones"
                    :key="phone"
                    variant="outline"
                    class="hover:bg-primary-100 rounded-lg bg-white"
                    icon="lucide:phone"
                    :label="phone"
                    :href="formatPhoneLink(phone)"
                />
            </div>

            <BlockList :items="items" class="text-inverted" :list-style="{ type: 'icon', name: 'lucide:circle-check' }" />
        </div>
    </BlockSectionFullWidth>
</template>
